<style lang="scss" scoped>
@import '@@/assets/css/global.scss';
.container {
  box-sizing: border-box;
  .top {
    display: flex;
    flex-flow: wrap;
    justify-content: space-between;
    overflow: auto;
    .session {
      width: 49%;
      .title {
        margin-top: 30px;
        font-weight: bold;
        font-size: 16px;
      }

      .list {
        margin-top: 10px;
        .item {
          border-radius: 4px;
          border: 1px solid #ededed;
          padding: 12px;
          margin-bottom: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 14px;

          .left {
            .reason {
              max-width: 70px;
            }
          }

          .right {
            display: flex;
            align-items: center;
            margin-left: 10px;
            flex-shrink: 0;
            .minus {
              width: 50px;
              height: 28px;
              border-radius: 4px;
              color: white;
              font-size: 20px;
              font-weight: bold;
              background: #3875c4;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .number {
              margin-left: 10px;
              margin-right: 10px;
              max-width: 50px;
              font-size: 20px;
              text-align: center;
            }

            .plus {
              width: 50px;
              height: 28px;
              border-radius: 4px;
              color: white;
              font-size: 20px;
              font-weight: bold;
              background: #3875c4;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
    }
  }

  .bottom {
    padding-bottom: 20px;
    .sum {
      font-weight: bold;
      font-size: 18px;
      color: $c-error;
      margin-bottom: 10px;
    }
  }
}
</style>
<template>
  <div v-loading="loading">
    <div class="container" ref="container">
      <div class="top" :style="{ height: topHeight + 'px' }">
        <div class="session" v-for="(type, index) in faultTypeNameArr" :key="type[0]">
          <div class="title">{{ index + 1 }}.{{ type[1] }}</div>
          <div class="list">
            <div class="item" v-if="code.faultTypeId == type[0]" v-for="(code, index) in faultCodeArr" :key="code.id">
              <div class="left">{{ code.descri === '' || code.descri === undefined ? code.code : code.descri }}</div>
              <div class="right">
                <div class="minus" @click="minus(index)">-</div>
                <div class="number">{{ code.number }}</div>
                <!-- <input type="number" class="number" v-model="code.number" placeholder=" " /> -->
                <div class="plus" @click="plus(index)">+</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bottom" ref="bottom" style="text-align: center;width:100% ;margin-top: 20px;">
        <div class="sum">{{ $t('buliangpinzongshu') }}：{{ sum }}</div>
        <el-button style="width: 40%;height: 50px;" class="post" @click="saveUnqualified" type="primary">{{ $t('tijiao') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gongdan_buliang',
  components: {},
  props: {
    wo: null,
    height: 0
  },

  data() {
    return {
      wo: null,
      faultCodeArr: [],
      faultTypeNameArr: [],
      faultCodeArr: [],
      loading: false,
      topHeight: 0,
      canSave: false
    };
  },

  computed: {
    sum() {
      let sum = 0;
      this.faultCodeArr.forEach(code => {
        if (code.number) {
          sum += parseInt(code.number);
        }
      });
      return sum;
    },
    woid() {
      return this.wo ? this.wo.id : null;
    }
  },
  watch: {
    woid: {
      handler(n, o) {
        this.getfaultCodeArr();
      },
      immediate: true,
      deep: true
    },
    faultCodeArr: {
      handler(n, o) {
        //因为请求的时候会覆盖掉,所以标识开始缓存的时候才缓存
        if (!this.canSave) {
          return;
        }

        this.global.faultCodeArr = {};
        this.global.faultCodeArr[this.wo.id] = n;
      },
      immediate: true,
      deep: true
    }

    // height: {
    // 	handler(n, o) {
    // 		this.setHeight()
    // 	},
    // 	immediate: true,
    // 	deep: true,
    // },
  },
  created() {},

  mounted() {},
  beforeDestroy() {},

  methods: {
    // setHeight(){
    // 	setTimeout(()=>{
    // 	if(this.$refs.bottom.offsetHeight!=0){
    // 		this.topHeight = this.height-60 - this.$refs.bottom.offsetHeight
    // 	}else{
    // 		this.setHeight()
    // 	}},300)
    // },
    minus(index) {
      if (this.faultCodeArr[index].number == 0) {
        return;
      }
      this.faultCodeArr[index].number--;
    },
    plus(index) {
      this.faultCodeArr[index].number++;
    },
    getfaultCodeArr() {
      this.loading = true;
      this.faultCodeArr = [];
      this.faultTypeNameArr = [];
      this.faultCodeArr = [];

      this.http
        .post('/production/qualityfaultcode/listAllByCustomerCode')
        .then(res => {
          for (var i = 0; i < res.length; i++) {
            res[i].number = 0;
          }
          this.faultCodeArr = res;
          let faultTypeNameMap = new Map();
          let faultSubTypeNameMap = new Map();
          this.faultCodeArr.forEach(fc => {
            faultTypeNameMap.set(fc.faultTypeId, fc.faultTypeName);
            // faultSubTypeNameMap.set(fc.faultSubTypeId, fc.faultSubTypeName);
          });
          this.faultTypeNameArr = Array.from(faultTypeNameMap);
          // this.faultSubTypeNameArr = Array.from(faultSubTypeNameMap);
          console.log(this.faultTypeNameArr, this.faultSubTypeNameArr);

          //这里放开缓存
          this.canSave = true;
          //这里取出缓存对比写入
          if (this.global.faultCodeArr && this.global.faultCodeArr[this.wo.id]) {
            let old = this.global.faultCodeArr[this.wo.id];
            old.forEach(item => {
              for (let i = 0; i < this.faultCodeArr.length; i++) {
                if (this.faultCodeArr[i].id == item.id) {
                  this.faultCodeArr[i].number = item.number;
                }
              }
            });
          }

          //这里更新高度
          this.topHeight = this.height - 60 - this.$refs.bottom.offsetHeight;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    saveUnqualified() {
      this.loading = true;
      let data = [];
      for (let i = 0; i < this.faultCodeArr.length; i++) {
        if (this.faultCodeArr[i].number > 0) {
          data.push([this.faultCodeArr[i].code, this.faultCodeArr[i].number]);
        }
      }
      let params = {
        orderNo: this.wo.no,
        data: JSON.stringify(data)
      };
      this.http
        .post('/production/woqc/saveUnqualified', params)
        .then(res => {
          this.utils.successMessage('luruchenggong');
          //归零
          for (let i = 0; i < this.faultCodeArr.length; i++) {
            if (this.faultCodeArr[i].number > 0) {
              this.faultCodeArr[i].number = 0;
            }
          }
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
